module.exports = __webpack_public_path__ + "static/media/siddharth-guntur-trip-22.cf4a286b.png";